import { NG_VALUE_ACCESSOR, ControlValueAccessor, AbstractControl, ControlContainer } from '@angular/forms'
import {
	Component,
	EventEmitter,
	forwardRef,
	Host,
	Input,
	OnInit,
	Optional,
	Output,
	SkipSelf,
} from '@angular/core'

const nd = () => {}

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => InputComponent),
	multi: true,
}

@Component({
	selector: 'app-input',
	templateUrl: './input.component.html',
	styleUrls: ['./input.component.scss'],
	providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class InputComponent implements ControlValueAccessor, OnInit {
	private control: AbstractControl
	private innerValue: any = ''
	private onTouchedCallback: () => void = nd
	private onChangeCallback: (_: any) => void = nd

	@Input() formControlName: string
	@Input() border = true
	@Input() icon: string
	@Input() label: string
	@Input() placeholder: string
	@Input() name: string
	@Input() type = 'text'
	@Input() inputmode = 'text'
	@Input() mask = '&*'
	@Input() valid = false
	@Input() hint: string
	@Input() featuredEnabled = true
	@Input() hasError = false
	@Input() errorMsg: string
	@Input() autofocus = false
	@Input() autocomplete = 'off'
	@Input() thousandSeparator = null
	@Input() currencyMask = false
	@Input() readonly = false

	@Output() ngModelChangeEmitter = new EventEmitter()

	constructor(
		@Host()
		@Optional()
		@SkipSelf()
		private controlContainer: ControlContainer
	) {}

	ngOnInit(): void {
		if (this.controlContainer) {
			if (this.formControlName) {
				this.control = this.controlContainer.control.get(this.formControlName)
			} else {
				console.warn('No FormControlName directive from host element of the component')
			}
		} else {
			console.warn("Can't find parent FormGroup")
		}
	}

	get value(): any {
		return this.innerValue
	}

	set value(v: any) {
		if (v !== this.innerValue) {
			this.innerValue = v
			this.onChangeCallback(v)
		}
	}

	onBlur(): void {
		this.onTouchedCallback()
	}

	ngModelChange(): void {
		this.ngModelChangeEmitter.emit()
	}

	onKeyUp(): void {
		this.hasError = this.control.invalid && this.control.touched
	}

	writeValue(value: any): void {
		if (value !== this.innerValue) {
			this.innerValue = value
		}
	}

	registerOnChange(fn: any): void {
		this.onChangeCallback = fn
	}

	registerOnTouched(fn: any): void {
		this.onTouchedCallback = fn
	}

	onPhoneNumberChange(phoneNumber: string): void {
		this.innerValue = phoneNumber;
		this.control.setValue(phoneNumber);
	}
}
